$(document).ready(function() {
    var pathname = window.location.pathname;
    var customer_id;
    var variant_id;
    var giftUrl;

    // Check if Food Hall
    // if(pathname.includes("/collections/food-hall") && $(window).width() <= 768) {
    if (pathname.includes("/collections") || (pathname.includes("/search") && window.location.search)) {
        var onLoadShown = localStorage.getItem("onLoadReferralShow");

        if(!onLoadShown && $("#referral-modal").length > 0 && $("#on-load-content").length > 0) {
            $("#referral-modal").css("display", "flex");
            $("#on-load-content").show();
            localStorage.setItem("onLoadReferralShow", true);
        }

        customer_id = $(".referral_customer_id").val();
        getCustomerRemainingQuota(customer_id);

        let lastProductCount = 0;

        const observer = new MutationObserver((mutations) => {
            const currentProductCount = $('.product-card').length;
    
            // Verifica se a contagem de produtos aumentou
            if (currentProductCount > lastProductCount) {
                lastProductCount = currentProductCount;
    
                getCustomerRemainingQuota(customer_id);
            }
        });
    
        const productGrid = document.getElementById('ProductGrid');
        if (productGrid) {
            observer.observe(productGrid, {
                childList: true,
                subtree: true
            });
        } else {
            console.error('Elemento #ProductGrid não encontrado.');
        }

        $(document).on("click", ".envoy_create_referral_link", async function() {
            $("#on-load-content").hide();
            $("#referral-modal").css("display", "flex");
            $("#referral-steps").show();
            $("#referral-steps .step-1").show();
            $("#referral-steps .step-2").hide();
            $("#copy-referral-link").text('Copy');

            // Pixel event - Click to show referral popup
            await createPixelEvent("Gift referral button popup shown");

            variant_id = $(this).closest(".product-card__figure").find(".cheapest_variant_id").val();
        });

        $("#create-referral-link").on("click", async function() {
            // Pixel event - Click to create/share referral link
            await createPixelEvent("Referral link created");

            giftUrl = await createEnvoyGiftLink(customer_id, variant_id);
            getCustomerRemainingQuota(customer_id);

            $('input.referral-link-input').val(giftUrl);
            // $("input.referral-link-input").val("https://home-cooks.co.uk/collections/food-hall");

            $("#referral-steps .step-1").hide();
            $("#referral-steps .step-2").show();
        })

        $("#copy-referral-link").on("click", async function() {

            $("input.referral-link-input").select();
            navigator.clipboard.writeText($("input.referral-link-input").val());

            $(this).text('✔');
        })

        $("#share-referral-link").on("click", async function() {
            const shareData = {
                title: "Share this referral gift",
                text: "Share a Homecooks meal with a friend. It's free!",
                url: giftUrl
            }

            if(navigator.share) {
                await navigator.share(shareData);
            }
        })
    }

    // Get current user Envoy remaining quota
    function getCustomerRemainingQuota(customerId) {
        console.log("Dados: ", customerId);
        makeEnvoyApiRequest(`user-quota/${customerId}`, "GET")
        .then(async data => {
            console.log("Dados quota: ", data);
            $(".envoy_create_referral_link").css("display", "flex");
            if(data.userRemainingQuota > 0) {
                // Pixel event - Referral button with quota loaded
                await createPixelEvent("Referral button loaded on page");
                
                $(".customer_remaining_quota").text(data.userRemainingQuota);
                $(".envoy_create_referral_link").addClass("envoy_create_referral_link_shine");
            }

            if(data.userRemainingQuota <= 0) {
                $(".envoy_create_referral_link").removeClass("envoy_create_referral_link_shine");
                $(".customer_remaining_quota").text("0");
                $(".envoy_create_referral_link").css("background-color", "rgb(18,38,39)");
                $(".envoy_create_referral_link").addClass("no-quota");
                $("#create-referral-link").text("No gifts available, try again later");
                $("#create-referral-link").css({"background-color": "#bcbcbc", "pointer-events": "none"});
            }
        })
        .catch(error => {
            console.error('Error retrieving customer quota:', error);
        });
    }

    async function createPixelEvent(eventName) {
        try {
            const bodyData = {
                "event_name" : eventName
            };
            const data = await makeEnvoyApiRequest('pixel-event', 'POST', bodyData);
            return data;
        } catch (error) {
            console.error('Error in Pixel Event', error);
            return 0;
        }
    }

    async function createEnvoyGiftLink(customerId, variantId) {
        const bodyData = {
            "content_setting": {
                "content_type": "VIDEO",
                "content_name": "Your new best friend has sent you a free meal.",
                "content_description": "You will be sent a restaurant quality Homecooks ready meal made by an independent chef - enjoy!",
                "video_orientation": "vertical",
                "common": {
                    "source": "https://prod-envoy-assets.s3.eu-west-2.amazonaws.com/media_uploads/HomeCooks+Video.mp4",
                    "source_is_redirect": false,
                    "poster": "https://prod-envoy-assets.s3.eu-west-2.amazonaws.com/media_uploads/Still+Frame+HomeCooks.png"
                }
            },
            "sharer_id": `${customerId}`,
            "extra": {
                "user_id": `${customerId}`,
                "variant_id": `${variantId}`
            }
        }

        return makeEnvoyApiRequest("create-link", "POST", bodyData)
        .then(data => {
            return data.url;
        })
        .catch(error => {
            console.error('Error retrieving customer quota:', error);
        });
    }

    function makeEnvoyApiRequest(endpoint, method, data = null) {
        const url = `https://dev.escolhadigital.com/Homecooks/envoy-api.php?endpoint=${endpoint}&method=${method}`;
                
        var options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        if (method === 'POST' && data) {
            options.method = 'POST';
            options.body = JSON.stringify(data);
        }

        return fetch(url, options)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Erro ao fazer requisição para a API');
                }
                return response.json();
            })
            .then(data => {
                return data;
            })
            .catch(error => {
                console.error('Erro:', error);
                return null;
            });
    }
})